export default function getResource(label, vars = []) {
    const resources = {
        title: 'My Saved Addresses',
        cancel: 'Cancel',
        confirm: 'Use This Address',
        noAddresses: 'No saved addresses',
        showMore: 'Show all',
        showLess: 'Show less',
        defaultLabel: 'Default',
        editLabel: 'Edit',
        removeLabel: 'Remove',
        removeAddressLabel: 'Remove address',
        editAddressLabel: 'Edit address',
        addShippingAddress: 'Add new address'
    };

    return resources[label];
}
